import { useMemo } from 'react';
import recommend, { RecommendationsQuery } from '@algolia/recommend';
import { useAlgoliaConfig } from '~/shared/hooks/useAlgoliaConfig';
import { useQuery } from 'react-query';
import { useObjectIds } from '~/templates/blocks/components/carousel/hooks/useObjectIds';
import { AlgoliaHit } from '~/templates/blocks/components/carousel/models';

type Options = Omit<RecommendationsQuery, 'indexName' | 'objectID'>;

export const useFrequentlyBoughtTogether = (options?: Options, enabled?: boolean) => {
    const { defaultIndex: indexName, key, token } = useAlgoliaConfig();
    const objectIds = useObjectIds();
    const frequentlyBoughtTogetherQueryKey = [
        `algoliaRecommend_${options?.model || ''}`,
        { objectIds, indexName },
    ];
    const queries = useMemo(
        () => objectIds.map((objectID) => ({ indexName, objectID, ...options })),
        [indexName, objectIds, options]
    );

    const recommendClient = useMemo(() => recommend(key, token), [key, token]);

    const { data: hits, isLoading } = useQuery<AlgoliaHit[]>(
        frequentlyBoughtTogetherQueryKey,
        async () => {
            const { results } =
                options?.model === 'related-products'
                    ? await recommendClient.getRelatedProducts<AlgoliaHit>(queries)
                    : await recommendClient.getFrequentlyBoughtTogether<AlgoliaHit>(queries);
            return results?.[0]?.hits || [];
        },
        {
            enabled,
        }
    );

    return {
        hits,
        isLoading,
    };
};
